import React, { Component, Fragment } from 'react';
import _ from 'lodash';
import Button from '@material-ui/core/Button';
import GridItem from '../components/GridItem';
import AppBar from '@material-ui/core/AppBar';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import Divider from '@material-ui/core/Divider';
import CheckCircle from '@material-ui/icons/CheckCircle';
import RemoveCircle from '@material-ui/icons/RemoveCircle';
import { Link } from 'react-router-dom'
import dbProject from '../db.json';

const isSelected = (id1, id2) => id1 === id2;

const LayerItem = ({
  id,
  isSelected = false,
  onClick,
  url,
  isFullSize = false,
  isVisible,
  isComplete,
  onClickComplete,
  onClickVisible
}) => {

  // this is a hack because button clicks are also triggering the paper on click
  let wasButtonClickedFirst = false
  return (
    <Paper
      className={
        classNames("layer", { "selected": isSelected, "small": isFullSize, "complete": isComplete})
      }
      onClick={() => {
        console.log('e!!! 1', wasButtonClickedFirst)
        if (!wasButtonClickedFirst) {
          onClick && onClick(id)
        } else {
          wasButtonClickedFirst = false;
        }
      }}
    >
      <div className="layer-actions">
        <Button
          onClick={e => {
            console.log('e!!! 2', wasButtonClickedFirst)
            e.preventDefault();
            wasButtonClickedFirst = true;
            onClickVisible && onClickVisible(id);
          }}
        >
          { isVisible ? (<CheckCircle className={"layer-icon-complete"} />) : (<RemoveCircle color="primary" />) }
          { isVisible ? "Visible" : "Hidden" }
        </Button>
        <Button
          onClick={() => {
            wasButtonClickedFirst = true;
            onClickComplete && onClickComplete(id)
          }}
        >
          { isComplete ? (<CheckCircle className={"layer-icon-complete"}  />) : (<RemoveCircle color="primary" />) }
          { isComplete ? "Complete" : "Incomplete" }
        </Button>
      </div>
      <img src={url} className="layer-image" />
    </Paper>
    )
}

class GridContainer extends Component {
  state = {
    images: [],
    imagesOrd: [],
    imageAspectRatios: {},
    imageStyles: {},
    columns: 4,
    reverseImages: false,
    isFirstRender: true,

    project: {},
    selectedLayer: null,
    layersSmall: true,
    showCompleted: false,
    showVisible: false,
    showGrid: true,
    left: 0,
    top: 0,
    zoomed: false,
  }

  constructor() {
    super();
    this.container = React.createRef();
    this.setRatio = this.setRatio.bind(this);

    // we need to store several tops for each column keyed by column index
    this.lastTop = {};
    this.lastLeft = 0;
  }

  async componentDidMount() {
    const id = this.props.match.params.id;
    // const results = await fetch(`http://localhost:3001/my-projects/${id}`)
    // const project = await results.json();
    const myProjects = dbProject['my-projects'];
    const project = myProjects.find(pro => Number(pro.id) === Number(id));
    console.log('myProjects',myProjects)

    project.layers =  project && project.layers && _.keyBy(project.layers, 'id');
    this.setState({
      project,
      images: [],// data,
      imagesOrd: [], //data.slice(),
      imageStyles: []//_.keyBy(data.slice(), 'id')
    })
  }


  componentDidUpdate() {
    const {
      images,
      imageAspectRatios,
      isFirstRender
    } = this.state;

    const isLoaded = images.length === _.values(imageAspectRatios).length;

    if (isFirstRender && isLoaded) {

    }
  }

  setRatio(id, width, height) {
    const ratio = height / width;
    this.setState({
      imageAspectRatios: {
        ...this.state.imageAspectRatios,
        [id]: ratio
      }
    });
  }

  setOriginImageVisible(id) {
    const { project } = this.state;
    const newProject = {
      ...project,
      image: {
        ...project.image,
        visible: !project.image.visible
      }
    }

    this.setState({
      project: newProject
    })
  }

  setOriginImageCompleted(id) {
    const { project } = this.state;
    const newProject = {
      ...project,
      image: {
        ...project.image,
        complete: !project.image.complete
      }
    }

    this.setState({
      project: newProject
    })
  }

  setVisible(id) {
    const { project } = this.state;
    const newProject = {
      ...project,
      layers: {
        ...project.layers,
        [id]: {
          ...project.layers[id],
          visible: !project.layers[id].visible
        }
      }
    }

    this.setState({
      project: newProject
    })
  }

  setAllVisible(id) {
    const { project } = this.state;
    const newProject = {
      ...project,
       image: {
        ...project.image,
        visible: true,
      },
      layers: _.mapValues(project.layers, layer => ({
        ...layer,
        visible: true
      }))
    }

    this.setState({
      project: newProject
    })
  }

  setAllHidden(id) {
    const { project } = this.state;
    const newProject = {
      ...project,
      image: {
        ...project.image,
        visible: false,
      },
      layers: _.mapValues(project.layers, layer => ({
        ...layer,
        visible: false
      }))
    }

    this.setState({
      project: newProject
    })
  }

  setCompleted(id) {
    const { project } = this.state;
    const newProject = {
      ...project,
      layers: {
        ...project.layers,
        [id]: {
          ...project.layers[id],
          complete: !project.layers[id].complete
        }
      }
    }

    this.setState({
      project: newProject
    })
  }

  setView(obj) {
    this.setState({
      selectedLayer: null,
      layersSmall: true,
      showCompleted: false,
      showVisible: false,
      ...obj,
    })
  }

  isVisible(layer) {
    const {
      selectedLayer,
      showCompleted,
      showVisible,
    } = this.state;



    if (!layer) {
      return false;
    }

    if (selectedLayer !== null) {
      return selectedLayer === layer.id;
    }

    if (showCompleted) {
      return layer.complete;
    }

    if (showVisible) {
      return layer.visible;

    }

    return layer.visible || layer.complete
  }

  render() {
    const {
      images,
      imageAspectRatios,
      imageStyles
    } = this.state;

    const isImages = images.length;
    const { project, selectedLayer, layersSmall, showGrid, top, left, zoomed } = this.state;
    const isLoaded = images.length === _.values(imageAspectRatios).length;

    return (
      <Fragment>
      <AppBar className="navigation">
         <Typography inline variant="h5" className="header-text">
           <Link to='/my-projects' className="header-text">
            {`Projects > ${project.name}`}
           </Link>
          </Typography>
      </AppBar>
      <Paper className="sidebar">
        <div className="sidebar-header">
          <Typography inline variant="secondary" variant="h6" className="sidebar-header">
            Layers
          </Typography>
        </div>
         <LayerItem
            url={project.image && project.image.url}
            isFullSize={layersSmall}
            isVisible={project.image && project.image.visible}
            isComplete={project.image && project.image.complete}
            onClickComplete={id => this.setOriginImageCompleted(id)}
            onClickVisible={id => this.setOriginImageVisible(id)}
          />
          {
            project.layers && _.map(project.layers, layer => {
              return (
                <LayerItem
                  id={layer.id}
                  url={layer.url}
                  onClick={id => this.setState({ selectedLayer: id })}
                  isSelected={isSelected(layer.id, selectedLayer)}
                  isFullSize={layersSmall}
                  isVisible={layer.visible}
                  isComplete={layer.complete}
                  onClickComplete={id => this.setCompleted(id)}
                  onClickVisible={id => this.setVisible(id)}
                />
              )
            })
          }
      </Paper>
      <div className="container">
        <div
          className="grid-container"
        >
            <Button
              onClick={() => this.setView({ selectedLayer: null, zoomed: false })}
            >
              Reset
            </Button>
            <Button
              onClick={() => this.setView({ showCompleted: true })}
            >
              Completed
            </Button>
            <Button
              onClick={() => this.setView({ showVisible: true })}
            >
              Visible
            </Button>
            <Button
              onClick={() => this.setAllHidden()}
            >
              Hide all
            </Button>
            <Button
              onClick={() => this.setAllVisible()}
            >
              Show all
            </Button>
           <Button
              onClick={() => this.setState({ layersSmall: !layersSmall })}
            >
              { layersSmall ? "Full size" : "Small size" }
           </Button>
            <Button
              onClick={() => this.setState({ showGrid: !showGrid})}
            >
              Grid
            </Button>
          </div>
          <div
            className="main-container"
            ref={this.container}
          >
              <GridItem
                show={this.isVisible(project.image && project.image)}
                key={project.name}
                id={project.name}
                showGrid={showGrid}
                left={left}
                top={top}
                zoomed={zoomed}
                url={project.image && project.image.url}
                style={true ? imageStyles[project.id] : {}}
              />
              {
                project.layers && _.map(project.layers, layer => {
                  return (
                    <GridItem
                      show={this.isVisible(layer)}
                      key={layer.id}
                      id={layer.id}
                      url={layer.url}
                      setRatio={this.setRatio}
                      showGrid={showGrid}
                      left={left}
                      top={top}
                      zoomed={zoomed}
                      onClickGridLine={pos => this.setState(pos)}
                      style={isLoaded ? imageStyles[layer.id] : {}}
                    />
                  )
                })
              }

          </div>
      </div>
      </Fragment>
    )
  }
}

export default GridContainer;


// WEBPACK FOOTER //
// ./src/containers/GridContainer.js